import { render, staticRenderFns } from "./multipleChoice8.vue?vue&type=template&id=f0c93fc8&scoped=true"
import script from "./multipleChoice8.vue?vue&type=script&lang=js"
export * from "./multipleChoice8.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice8.vue?vue&type=style&index=0&id=f0c93fc8&prod&lang=css"
import style1 from "./multipleChoice8.vue?vue&type=style&index=1&id=f0c93fc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c93fc8",
  null
  
)

export default component.exports